var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-application d-block",attrs:{"id":"genscanApp","data-app":"true"}},[_c('div',{staticClass:"navContainer"},[_c('NavBarAdmin')],1),_c('div',{staticClass:"container-fluid pt-1"},[_c('EmptyRouterView')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }